<template>
  <!-- <div>
    <v-tabs
      v-model="tab"
      color="white"
      show-arrows
      class="card-rounded elevation-2"
      hide-slider
    >
      <v-tab v-for="sponsor in filteredsponsor" color="yellow" :key="sponsor">
        {{ sponsor }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="sponsor in filteredsponsor" :key="sponsor">
        <tabcontent :sponsor="sponsor" class="card-rounded elevation-2" />
      </v-tab-item>
    </v-tabs-items>
  </div> -->
  <v-layout wrap v-if="!viewPage">
    <v-flex
      v-for="(sponsor, key) in filteredsponsor"
      :key="key"
      md4
      xs12
      pa-2>
      <v-card flat >
        <v-card-title>
          {{sponsor}}
          <v-spacer />
          <v-chip small>
            <v-avatar class="primary white--text">
              <b>{{getPublications(sponsor).length}}</b>
            </v-avatar>
            publicações
          </v-chip>
        </v-card-title>

        <v-divider />
        <div style="position: relative;">
          <v-img
            height="120"
            contain
            class="mx-5"
            :src="getSponsor(sponsor).image"
          ></v-img>
          <v-btn
            style="bottom: -15px; background-color: #fff!important"
            @click="openLink(sponsor)"
            color="grey"
            absolute
            right
            outline
            small
            flat
            round>
            visitar site
          </v-btn>
        </div>

        <v-divider />

        <v-card-text class="pt-4">
          <span><i>Conteúdos:</i></span>
          <v-list dense>
            <v-list-tile
              v-for="(item, key) in getGroupsOptions(sponsor)"
              :key="key"
              @click="viewSponserPage(sponsor, item)"
            >
              {{item}}
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout v-else>
    <sponsorContent 
      :publications.sync="selectedSponsor"
      :selectedPublication.sync="selectedPublication"
      v-on:closeModal="viewPage = false"
    />
  </v-layout>
</template>

<script>
import _ from 'lodash'
import cms from '@/content'
import tabcontent from './tabContentSponsor'
import sponsorContent from './sponsorContent'
import { mapGetters } from 'vuex'
import { Sponsors } from '../../models/Content'
export default {
  components: {
    tabcontent,
    sponsorContent
  },
  data() {
    return {
      tab: null,
      imagelogo: cms.getlogotypes(),
      viewPage: false,
      selectedSponsor: {},
      selectedPublication: ''
    }
  },
  computed: {
    ...mapGetters(['user']),

    filteredsponsor() {
      const sponsorsresponse = _.uniqBy(
        Sponsors.query()
          .where(group => {
            return group.specialty.includes(this.user.specialty)
          })
          .get()
          .map(function (sponsor) {
            return sponsor['sponsor']
          })
      )
      return sponsorsresponse ? sponsorsresponse : ''
    },
    sponsers() {
      const items = Sponsors.query()
        .where(group => {
          return group.specialty.includes(this.user.specialty)
        })
        .get()
      return items
    }
  },

  methods: {
    getSponsor(sponsor) {
      return _.find(this.imagelogo, ['text', sponsor])
    },
    getPublications(sponsor) {
      const sponsors = JSON.parse(JSON.stringify(this.sponsers))
      return sponsors.filter(item => item.sponsor === sponsor)
    },
    getGroupsOptions(sponsor) {
      const groups = Sponsors.query()
        .where(group => {
          return (
            group.specialty.includes(this.user.specialty) &&
            group.sponsor === sponsor &&
            group.show === true
          )
        })
        .get()
        .map(group => group.group)
      return groups ? _.uniq(groups) : ''
    },
    openLink(sponsor) {
      const url = this.getSponsor(sponsor).link
      window.open(url, '_blank')
    },
    viewSponserPage(sponsor, item) {
      this.selectedPublication = item
      this.selectedSponsor = {
        sponsor: this.getSponsor(sponsor),
        groups: this.getGroupsOptions(sponsor),
        publications: this.getPublications(sponsor),
        selected: item
      }
      this.viewPage = true
    }
  },

  async created() {
    const sponsor = Sponsors.query().get()
    if (!sponsor.length) {
      await Sponsors.fetch()
    }
  }
}
</script>
